/**
 * 单词-体验课-学习模块API
 * @data 2020-11-19 09:00:03
 * @aouthor 南枫 
 */

import {httpPost} from "../http/axios";

export function selectUnit(data) {
    return httpPost('/api/word_experience/choice_unit', data, '单词学习选择单元')
}

export function getUnitWord(data) {
    return httpPost('/api/word_experience/get_word', data, '单词学习获取单词')
}

export function clickWordFace(data) {
    return httpPost('/api/word_experience/save_study', data, '更新数据并获取下一条数据')
}

export function unitWordSaveQuit(data) {
    return httpPost('/api/word_experience/save_quit', data, '单词学习-保存退出')
}

export function breakQuit(data) {
    return httpPost('/api/word_experience/break_quit', data, '单词学习-中途退出')
}

export function unitMemory(data) {
    return httpPost('/api/word_experience/unit_memory', data, '单词学习-单元整体回忆')
}

export function quitUnitMemory(data) {
    return httpPost('/api/word_experience/quit_unit_memory', data, '单词学习-单元整体回忆-保存退出')
}